import { Box, Center } from '@chakra-ui/react'
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons'
import React from 'react'

export const ColumnResizeHandler = ({ header, ...props }) => {
  return (
    <Box
      {...props}
      onMouseDown={header.getResizeHandler()}
      onTouchStart={header.getResizeHandler()}
      position="absolute"
      right={0}
      top={0}
      transform="translateX(50%)"
      width="25px"
      height="100%"
      backgroundColor="transparent"
      zIndex={9}
      touchaction="none"
      userSelect="none"
      cursor="col-resize">
      <Center
        w="100%"
        h="100%">
        <ChevronLeftIcon color="brand.textGray" />
        <Box
          height="20px"
          w="2px"
          backgroundColor="brand.textGray"
        />
        <ChevronRightIcon color="brand.textGray" />
      </Center>
    </Box>
  )
}
